import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "../App.css";

import mobility1 from "../assets/breathwork1.jpeg";
import mobility2 from "../assets/mobility.jpeg";
import mobility3 from "../assets/mobility.jpeg";

const VerticalSwiper1 = () => {
  const images = [mobility1, mobility2, mobility3, mobility1, mobility2, mobility3];

  return (
    <div className="swiper-bg-container">
      <Swiper
        modules={[Autoplay]}
        direction="vertical"
        slidesPerView={3}
        spaceBetween={20}
        loop={true}
        autoplay={{ delay: 2500, disableOnInteraction: false }}
        className="verticalImageSwiper"
      >
        {images.map((img, index) => (
          <SwiperSlide key={index}>
            <div className="slide-overlay-wrapper">
              <img src={img} alt={`Slide ${index + 1}`} className="vertical-image" />
              <div className="side-dark-overlay"></div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default VerticalSwiper1;
